import { checkMaliciousExtension } from '@/utils/env'
import useUniversalNavigate from '@/utils/hooks/useUniversalNavigate'
import { clearUserSession } from '@/utils/navigate'
import { useInterval } from '@mantine/hooks'

export default function MaliciousExtensionDetectorService() {
	const navigate = useUniversalNavigate()

	useInterval(() => {
		if (checkMaliciousExtension()) {
			clearUserSession()
			navigate({ to: '/abnormal-environment' })
		}
	}, 5000)

	return null
}
